export const boardFlowChartTour = {
  key: "boardFlowChart",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-flowchart-shapes"]',
      content: t("Tour_BoardFlowChart_Shapes"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-addnode"]',
      content: t("Tour_BoardFlowChart_AddNode"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-dragdrop"]',
      content: t("Tour_BoardFlowChart_DragDrop"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-connect"]',
      content: t("Tour_BoardFlowChart_Connect"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-controls"]',
      content: t("Tour_BoardFlowChart_Controls"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-export"]',
      content: t("Tour_BoardFlowChart_Export"),
      placement: "bottom",
    },
  ],
};
